import React from 'react';
import PropTypes from 'prop-types';
import lunr from 'lunr';

import { MaterialIcon, Input } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  CloseButton,
  SearchWrapper,
} from './styles';

import messages from '../messages';

function SearchContainer({ searchData, searchFilter, updateSearch, resetSearch }) {
  // eslint-disable-next-line func-names
  const lunrIndex = lunr(function () {
    // scoping of 'this' pertains to lunr.Builder
    this.field('id');
    this.field('title', { boost: 100 });
    this.field('tags', { boost: 10 });
    this.field('description');
    Object.keys(searchData).forEach((key) => {
      const item = searchData[key];
      const object = Object.assign({}, { id: key }, item);
      this.add(object);
    });
  });

  function onChange(changeEvent) {
    const queryTerm = changeEvent.target.value;
    if (queryTerm === '') {
      resetSearch();
      return;
    }
    const entries = lunrIndex.query((q) => {
      q.term(queryTerm, { usePipeline: true, boost: 100 });
      q.term(`${queryTerm}*`, { usePipeline: false, boost: 10 });
      q.term(queryTerm, { usePipeline: false, editDistance: 1 });
    });

    const items = Object.keys(entries).map((key) => {
      const item = entries[key];
      return searchData[item.ref];
    });

    updateSearch(queryTerm, items);
  }

  return (
    <SearchWrapper>
      <Input.Search
        width={'100%'}
        autoComplete="off"
        onChange={onChange}
        value={searchFilter}
        label={intl.formatMessage(messages.search)}
        placeholder={intl.formatMessage(messages.search)}
      />
      {searchFilter && (
        <CloseButton grey iconOnly onClick={resetSearch} >
          <MaterialIcon id="close" />
        </CloseButton>
      )}
    </SearchWrapper>
  );
}

SearchContainer.propTypes = {
  searchData: PropTypes.object,
  searchFilter: PropTypes.string,
  updateSearch: PropTypes.func,
  resetSearch: PropTypes.func,
};

export default SearchContainer;
